/* eslint-disable max-len */
export default {
  ACTIONS: {
    HOME: 'Início',
    LOGOUT: 'Sair',
    NEXT: 'Próximo',
    SUBMIT: 'Submeter',
    USERS: 'Utilizadores'
  },
  ERRORS: {
    BASE:
      'Alguma coisa não correu bem... Pedimos desculpa! Tenta novamente daqui a alguns minutos. 🥴'
  },
  MESSAGES: {
    NOT_FOUND: 'Página não encontrada',
    ORDER: 'Encomenda',
    OTHER: 'Outro',
    OTHER_RET: 'Outro...',
    PROZIS_NOW: 'PROZIS NOW',
    UNAUTHORIZED: 'Sem acesso'
  },
  SENTENCES: {
    NOT_FOUND: 'Não foi possível encontrar o que procuras.',
    UNAUTHORIZED:
      'Não tens acesso a este recurso. Se precisares de acesso, entra em contacto connosco.'
  }
};
